import { defineMessages } from 'react-intl';

export default defineMessages({
  attendanceOverview: {
    id: 'yield-management.schedule-detail-v2.attendance-card.attendance-overview',
    defaultMessage: 'Attendance overview',
  },
  attendedCount: {
    id: 'yield-management.schedule-detail-v2.attendance-card.attended-count',
    defaultMessage: '{count, plural, one {# client} other {# clients}} marked “Attended”',
  },
  markAttendance: {
    id: 'yield-management.schedule-detail-v2.attendance-card.mark-attendance',
    defaultMessage: 'Mark attendance',
  },
  markingBody: {
    id: 'yield-management.schedule-detail-v2.attendance-card.marking-body',
    defaultMessage:
      'If attendance isn’t recorded within 24 hours after class start, the client will automatically be marked as “Attended”. For integrated partners, attendance will sync automatically within 24 hours.',
  },
  missedCount: {
    id: 'yield-management.schedule-detail-v2.attendance-card.missed-count',
    defaultMessage: '{count, plural, one {# client} other {# clients}} marked “Missed”',
  },
  preClassBody: {
    id: 'yield-management.schedule-detail-v2.attendance-card.pre-class-body',
    defaultMessage: 'Attendance marking will become available 60 minutes before class start.',
  },
  viewPayoutReport: {
    id: 'yield-management.schedule-detail-v2.attendance-card.view-payout-report',
    defaultMessage: 'View payout report',
  },
});
